import { call, put, takeLatest } from 'redux-saga/effects';

import {
  LOADING_DATA_START,
  LOADING_DATA_FINISHED,
} from '../reducers/loading.reducer';

import { FOLDER_FETCH } from '../reducers/folder.reducer';

import * as extensionsActions from '../reducers/extensions.reducer';
import { handleError } from './helper';
import { extensionApi } from '../services';
import {
  EXTENSION_FETCH,
  EXTENSION_FETCH_FAILURE,
  EXTENSION_FETCH_SUCCESS,
  EXTENSION_SAVE,
  EXTENSION_SAVE_FAILURE,
  EXTENSION_SAVE_SUCCESS,
} from '../reducers/extension.reducer';

function* saveExtensionRequest({ payload: { extension } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    const { data } = extension.id
      ? yield call(extensionApi.editExtension, { extension })
      : yield call(extensionApi.createNewExtension, { extension });

    yield put({ type: EXTENSION_SAVE_SUCCESS, payload: data });
    yield put({ type: LOADING_DATA_FINISHED });
    yield put(extensionsActions.fetchExtensions());
    yield put({ type: FOLDER_FETCH });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: EXTENSION_SAVE_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}
function* fetchExtensionRequest({ payload: { id } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    const { data } = yield call(extensionApi.fetchExtension, { id });
    yield put({ type: EXTENSION_FETCH_SUCCESS, payload: data });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: EXTENSION_FETCH_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

export function* saveExtension() {
  yield takeLatest(EXTENSION_SAVE, saveExtensionRequest);
}

export function* fetchExtension() {
  yield takeLatest(EXTENSION_FETCH, fetchExtensionRequest);
}



// WEBPACK FOOTER //
// ./src/sagas/extension.saga.js